import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/new-website.css"
import Footer from "../layout/footerUpdated";
import Header from "../layout/headerHome";
import SliderLab from "../element/component/bannerNewSliderDental";
import ServiceSection from "../element/component/ServiceSectionDental";
import ServiceSectionGentle from "../element/component/ServiceSectionDentalGentle";
import FAQComponent from '../element/component/faq';
import WhyLab from '../element/component/whyDental';
import TestimonialSlider from "../element/component/testimonial-slider";
import ReachToUsForm from "../element/reachToUsDental";
import Popup_Main from "../element/component/Popup_Main";
import DentalServicesSlider from "../element/component/SliderDental";

const DentalCheckup = () => {
  const [activeTab, setActiveTab] = useState("clinics");
  const [isOpen, setIsOpen] = useState(false);
  const Counter = ({ targetValue, duration }) => {
    const [count, setCount] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
  
    useEffect(() => {
      let startValue = 0;
      const increment = targetValue / (duration / 50);
  
      const updateCounter = () => {
        startValue += increment;
        if (startValue >= targetValue) {
          setCount(Math.ceil(targetValue));
          setIsAnimating(false); // End animation
        } else {
          setCount(Math.floor(startValue));
          setIsAnimating(true); // Start animation
          requestAnimationFrame(updateCounter);
        }
      };
  
      setIsAnimating(true); // Initialize animation
      updateCounter();
    }, [targetValue, duration]);
  
    return <h3 className={isAnimating ? "animate-counter" : ""}>{count}%</h3>;
  };
  
  const whyData = [
    { title: "Comprehensive Care Under One Roof", image: "/images/new-website/dental/orthodontics.webp" },
    { title: "Digital-First Dentistry", image: "/images/new-website/dental/dental-scan-ai.webp" },
    { title: "Specialist-Led Treatment", image: "/images/new-website/dental/dental-aligners.webp" },
    { title: "Dental Care for Every Age", image: "/images/new-website/dental/orthodontist-new.webp" },
  ];

// Slider settings defined here
  const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "15%",
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: (
        <div className="slick-prev">
            <i className="fa fa-angle-left" style={{marginLeft:"-40px"}} aria-hidden="true"></i>
        </div>
        ),
        nextArrow: (
        <div className="slick-next">
            <i className="fa fa-angle-right" aria-hidden="true"></i>
        </div>
        ),
        responsive: [
          {
            breakpoint: 1024, // Tablet view
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768, // Mobile view
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
  };

  const slides = [
        {
           desktop: "/images/new-website/dental/Dental-clinic-6.webp",
           mobile: "/images/new-website/dental/Dental-clinic-6.webp",
        },
        {
          desktop: "/images/new-website/dental/dentalclinic2.webp",
          mobile: "/images/new-website/dental/dentalclinic2.webp",
        },
        // {
        //   desktop: "/images/new-website/dental/BH-Dental-slider-2.webp",
        //   mobile: "/images/new-website/dental/BH-Dental-slider-2.webp",
        // },
        {
          desktop: "/images/new-website/dental/dentalclinic3.webp",
          mobile: "/images/new-website/dental/dentalclinic3.webp",
        },
        {
           desktop: "/images/new-website/dental/Dental-clinic-5.webp",
           mobile: "/images/new-website/dental/Dental-clinic-5.webp",
        },
        {
          desktop: "/images/new-website/dental/dentalclinic1.webp",
          mobile: "/images/new-website/dental/dentalclinic1.webp",
        },
  ];

  const testimonials = [
    {
      content:
        "Bridge health offers services at affordable cost. Akshata at the front desk is very cooperative and good at coordinating and follow-ups. The staff are well spoken and carried out all tests with patience.",
      name: "Akshata J Lokhande",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "I am Prof Sundararaj living at PRIMUS REFLECTION. The staff are very courteous with a smile on their faces, including all the doctors. Special thanks to Ms. Akshita!",
      name: "Sundar Raj",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Good , clean hygiene place ... Feels like your are at home with the services that provide... I have enrolled for gym here.. And the trainers are thorough professionals.. And the staff I have interacted with them during the seminars or presentations they are knowledgeable",
      name: "Shiva Kumar S",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "From sattva apartment Bridge healthy is useful for our patients.Mahendra the nursing staff is good and courteous.",
      name: "Susheela Sharan",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Laxman is an excellent nurse looking after the retired community. Gentle in taking blood. Very polite and efficient.",
      name: "Dipak Rao",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
  ];

  const faqs = [
    {
      question: "What dental treatments are available at Bridge Health clinics? ",
      answer:
        "Bridge Health offers comprehensive dental care including general dentistry, preventive check-ups, cosmetic dentistry, orthodontics, periodontal care, root canal treatments, extractions, and clear aligner–based smile makeovers.",
    },
    {
      question: "Do you provide clear aligner treatment for teeth alignment?",
      answer: "Yes. Bridge Health provides complete clear aligner treatment, including digital smile scans, personalised aligners, and expert monitoring. We are an Invisalign Diamond Provider, offering end-to-end support for your smile journey.",
    },
    {
      question: "Are dental consultations available online or digitally? ",
      answer: "Yes. We offer digital consultations for select dental concerns, follow-ups, and treatment planning, along with in-clinic digital scans for accurate diagnosis and care.",
    },
    {
      question: "Do Bridge Health clinics in JP Nagar provide children’s or family dentistry?",
      answer: "Yes. Our JP Nagar clinic offers dental care for children, adults, and seniors, with orthodontists and periodontists experienced in family and paediatric dental care.",
    },
     {
      question: "Which is the best dental clinic in JP Nagar, Bangalore for painless dental treatment? ",
      answer: "Bridge Health is trusted for its patient-first approach, experienced dental specialists, advanced pain-management protocols, and AI-powered diagnostic technology — making dental care comfortable and stress-free. ",
    },
  ];

  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]); // Refs for multiple sections/cards
  const [hasAnimated, setHasAnimated] = useState([]); // Animation tracking for cards

  // Resize event listener to detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Animation Logic
  useEffect(() => {
    const handleScroll = () => {
      const updatedVisibility = sectionRefs.current.map((ref) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          // Element becomes visible when its top is within viewport
          return rect.top <= windowHeight - 50;
        }
        return false;
      });

      setHasAnimated((prev) =>
        updatedVisibility.map((visible, index) => prev[index] || visible)
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on mount to check initial visibility
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const cardsData = [
    { title: (<> Dental <span className="solutionbold">Implants</span></>), image: "/images/new-website/dental/dental-implants.webp" },
    { title: (<><span className="solutionbold">FMR</span> (Full Mouth Rehabs)</>), image: "/images/new-website/dental/fmr.webp" },
    { title: (<><span className="solutionbold">Invisalign</span> Treatment (Diamond Provider)</>), image: "/images/new-website/dental/invisalign.webp" },
    { title: (<><span className="solutionbold">Orthodontics</span> (Wires & Brackets)</>), image: "/images/new-website/dental/orthodontics.webp" },
    { title: (<><span className="solutionbold">Prosthontics</span> (Crowns and Bridges)</>), image: "/images/new-website/dental/prosthontics.webp" },
    { title: (<><span className="solutionbold">Periodontics</span></>), image: "/images/new-website/dental/periodontal.webp" },
    { title: (<>Single-Visit <span className="solutionbold">Endodontics</span></>), image: "/images/new-website/dental/endodontics.webp" },
    { title: (<>Dental <span className="solutionbold">Scans and Digital</span> Consults</>), image: "/images/new-website/dental/dental-scan.webp" },
  ];

    const cardsDataSmiles = [
    { title: (<>Preventive Dental Care</>), image: "/images/new-website/dental/preventive.webp", desc: "Regular dental assessments, cavity prevention and guidance to help protect developing teeth." },
    { title: (<>Gentle Treatment for Little Smiles</>), image: "/images/new-website/dental/gentle-treatment.webp", desc:"Child-friendly care for cavities and common dental concerns in a reassuring environment." },
    { title: (<>Healthy Habits from the Start</>), image: "/images/new-website/dental/healthy-habits.webp", desc: "Practical guidance on brushing, diet & age-appropriate dental care for children and parents."},
  ];

  return (
    <div>
      <Header/>
      {/* <div className={`landingcontainer ${isMobile ? "mobile" : ""}`}>
        <div className={`leftContainerDental ${isMobile ? "mobile" : ""}`}>
          <h1>
          Smile Without{" "}
            <span className="highlight1">Hesitation</span>
          </h1>
          <p className="paragraph-left-dental">Modern dentistry with expert hands - safe, precise & comfortable treatment </p>
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Book Your Free Consultation</button>
        </div>
        <div className="rightContainer">
          <img
            src="/images/new-website/dental/dental-check-up-bg.webp"
            alt="yoga-landing"
            className="imagelanding-dental imageFadeInUp"
          />
        </div>
      </div>
       */}
      
    <section className="aligner-hero">
      <div className="aligner-hero-inner">
        {/* LEFT CONTENT */}
        <div className="aligner-content">
          <h1>
            Smile Brighter <br />
            with Aligners
          </h1>

          <p>
            Invisible aligners, supported with complete dental care under one roof
          </p>

          <div className="service-section-button-dental-banner">
          <button className="dental-cta-btn" onClick={()=>setIsOpen(true)}>Book a Consultation</button>
        </div>
        </div>

        {/* RIGHT IMAGE */}
        {/* <div className="aligner-image">
          <img
            src="/images/new-website/dental/dental-banner.webp"
            alt="Invisible Aligners"
          />
        </div> */}
      </div>
    </section>
    
    <section>
            <div className="rightstrongcontainer">
            <h2 className="heading1">
            Preventive to Cosmetic.
              <span className="highlight1"> Under One Roof.</span>
              <span className="line-break-heading"></span>
            </h2>
            <p className="dental-text">From prevention and pain relief to smile correction and tooth replacement, find specialised dental care for every stage of your oral health journey.</p>
            </div>
              <ServiceSection
                cardsData={cardsData}
                isMobile={isMobile}
                highlight="For All Your Health Needs"
                heading="Personalised Offline & Online Yoga Classes"
                customClass="WellnessSectionWomen"
              />
              <div className="service-section-button">
                <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Request a Call Back</button>
              </div>
    </section>

    <section className="about-dental">
      <div className="about-dental-container">
        
        {/* LEFT IMAGE */}
        <div className="about-image">
          <div className="image-bg"></div>
          <img
            src="/images/new-website/dental/invisalign-image.webp"
            alt="Dental Care"
          />
          {/* <div className="experience-badge">
            <span className="years">22+</span>
            <span className="text">Years Experience</span>
          </div> */}
        </div>

        {/* RIGHT CONTENT */}
        <div className="about-content">

          <h2 className="heading1">
              <span className="highlight1"> Invisalign Aligners </span> for Beautiful, Straight Teeth
          </h2>
          <ul>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Invisalign® Diamond Provider expertise </li>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Accurate 3D digital scans for personalised planning </li>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Clear, removable aligners designed for everyday convenience </li>
          </ul>

          {/* <div className="stats">
            <div className="stat">
              <span className="number">98%</span>
              <span className="label">Invisalign Treatment Completed</span>
            </div>

            <div className="stat">
              <span className="number">100%</span>
              <span className="label">Patient Satisfaction Rate</span>
            </div>
          </div> */}

          <div className="service-section-button-dental">
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Know the Cost</button>
        </div>
        </div>
      </div>
    </section>

    <section className="about-dental">
      <div className="crown-dental-container">

        {/* RIGHT CONTENT */}
        <div className="about-content">

          <h2 className="heading1">
            
              <span className="highlight1"> Crowns</span> for Stronger, Natural-Looking Teeth
          </h2>
          <ul>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Advanced zirconia crowns for strength and aesthetics </li>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Crafted through accredited national dental laboratory partners</li>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Designed for a precise fit, natural shade and comfortable bite  </li>
          </ul>

          {/* <div className="stats">
            <div className="stat">
              <span className="number">98%</span>
              <span className="label">Crown Restorations Completed</span>
            </div>

            <div className="stat">
              <span className="number">100%</span>
              <span className="label">Patient Satisfaction Score</span>
            </div>
          </div> */}

          <div className="service-section-button-dental">
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Choose Your Fit </button>
        </div>
        </div>

          {/* LEFT IMAGE */}
        <div className="about-image">
          <div className="image-bg"></div>
          <img
            src="/images/new-website/dental/crowns-image.webp"
            alt="Dental Care"
          />
          {/* <div className="experience-badge">
            <span className="years">22+</span>
            <span className="text">Years Experience</span>
          </div> */}
        </div>
      </div>
    </section>

    <section className="about-dental">
      <div className="about-dental-container">
        
        {/* LEFT IMAGE */}
        <div className="about-image">
          <div className="image-bg"></div>
          <img
            src="/images/new-website/dental/dental-implants-services.webp"
            alt="Dental Care"
          />
          {/* <div className="experience-badge">
            <span className="years">22+</span>
            <span className="text">Years Experience</span>
          </div> */}
        </div>

        {/* RIGHT CONTENT */}
        <div className="about-content">

          <h2 className="heading1">
              <span className="highlight1">  Implants</span> for Stable, Long-Lasting Teeth
          </h2>
          <ul>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Titanium implant solutions for missing teeth </li>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Personalised planning based on bone health, bite and oral health</li>
            <li class="service-pointers"> <span style={{ color: "#0F6BB4", marginRight: "8px" }}>✓</span> Restorations designed for natural appearance and everyday function </li>
          </ul>

          {/* <div className="stats">
            <div className="stat">
              <span className="number">98%</span>
              <span className="label">Dental Implants Successfully Placed</span>
            </div>

            <div className="stat">
              <span className="number">100%</span>
              <span className="label">Patient Experience Score</span>
            </div>
          </div> */}

          <div className="service-section-button-dental">
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Explore Your Options </button>
        </div>
        </div>
      </div>
    </section>

    <section>
            <div className="rightstrongcontainer">
            <h2 className="heading1">
            Gentle Dental Care for 
              <span className="highlight1"> Growing Smiles</span>
              <span className="line-break-heading"></span>
            </h2>
            <p className="dental-text-gentle">Children experience dental care differently. Our child-focused dental care combines prevention, early intervention and gentle treatment to help make visits more comfortable while building healthy oral habits from an early age.</p>
            </div>
              <ServiceSectionGentle
                cardsData={cardsDataSmiles}
                isMobile={isMobile}
                highlight="For All Your Health Needs"
                heading="Personalised Offline & Online Yoga Classes"
                customClass="WellnessSectionWomen"
              />
              <div className="service-section-button">
                <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Book Your Child’s Dental Consultation</button>
              </div>
    </section>
          
<DentalServicesSlider />

{/* <section className="smile-cta-section">
      <div className="smile-cta-container">
        <div className="smile-cta-text">
          <span className="smile-cta-eyebrow">Preview Your Smile</span>
          <h2>Try Today. Smile Better Tomorrow.</h2>
          <p>
            Upload a selfie and preview your future smile before starting
            your aligner treatment.
          </p>
        </div>

        <a
          href="https://providerbio-apac.invisalign.com/sv/1897055#start"
          target="_blank"
          className="smile-cta-action"
        >
          Try Smile Preview
        </a>
      </div>
    </section> */}

<section className="smile-card">
      <div className="smile-content">
        <h2 className="smile-title">
          TRY TODAY. <br/> SMILE BETTER TOMORROW.
        </h2>

        <p className="smile-text">
          Upload a selfie and preview your future smile before starting your Invisalign aligner treatment.
        </p>

        <a
          href="https://providerbio-apac.invisalign.com/sv/1897055#start"
          target="_blank"
        >
        <button className="buttonlanding">Preview Your Smile</button>
        </a>
      </div>

      <div className="smile-image">
        <img
          src="/images/new-website/dental/invisalign-indian.webp"
          alt="Smile preview before and after"
        />
        <div className="invisalign-badge">
        <div className="invisalign-logo">
          <img
          src="/images/new-website/dental/invisalign-logo-powered.webp"
          alt="Smile preview before and after"
        />
        </div>
        </div>
      </div>
</section>

<section>
        <div className="yoga-types">
          <div className="yogastudioslider">
            <h2 className="heading1">Inside Our
              <span className="highlight1"> Dental Clinics</span>
            </h2>
          </div>
          <SliderLab sliderSettings={sliderSettings} slides={slides} />
        </div>
</section>

<section className="why-choose-section-radio">
          <h2 className="heading1">Why Choose <span className="highlight1">Bridge Health</span> For Dental Care?</h2>
                    
          <WhyLab
            whyData={whyData} 
            dynamicText="Radiology" 
            dynamicParagraph="We have some of the best specialists who bring years of experience and offer evidence – based treatment to ensure best care for you" 
          />
</section>

<section>
        <div>
        <FAQComponent faqs={faqs} />
        </div>
</section>

<section>
    <div className="testimonials-container">
      {/* Left Side */}
      <div className="left-section-testimonial">
        <h2>
        Trust Us Based on What Our <span className="highlight1">Patrons Say</span>
        </h2>
        <h3>Overall Ratings</h3>
        <div className="ratings">
          <img
            src="/images/new-website/women-care/google-logo-1.webp"
            alt="Google Logo"
          />
          <div>
            <p>
              4.9{" "}
              <span className="stars">
                ⭐⭐⭐⭐⭐
              </span>
            </p>
            <p>Customer Reviews</p>
          </div>
        </div>
        <a href="https://g.page/r/CagLkxSu4CfZEBM/review" target="_blank" rel="noopener noreferrer">
        <button className="buttonmaphome-review">Write a Review</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="right-section-testimonial">
        <div className="testimonial-page">
      <TestimonialSlider testimonials={testimonials} />
    </div>
      </div>
    </div>
</section>
        <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
        <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
        <Footer />
    </div>
  );
};

export default DentalCheckup;
